import React, { useState, useEffect } from 'react';
import clsx from 'clsx';
import { useStyles } from './styles';
import { useDispatch, useSelector } from 'react-redux';
import {
  getConfiguratorMenuComponents,
  getCoolingZoneComponents,
  getSelectedComponentWithOptions,
  getSelectedConfiguratorMenu,
} from '../../Reducers/App/Selectors';
import SelectorItem from './SelectorItem';
import { setSelectedComponent } from '../../Reducers/App/Actions';
import CoolingZoneSetup from './CoolingZoneSetup';
import ComponentsHeader from './ComponentsHeader';
import OptionsHeader from './OptionsHeader';
import SurroundingItem from './SurroundingItem';
import ComponentGroup from './ComponentGroup';

const ComponentSelector: React.FC = () => {
  const classes = useStyles();
  const components = useSelector(getConfiguratorMenuComponents);
  const selectedMenu = useSelector(getSelectedConfiguratorMenu);
  const selectedComponent = useSelector(getSelectedComponentWithOptions);
  const options = selectedComponent?.options;
  const coolingZoneComponents = useSelector(getCoolingZoneComponents);
  const dispatch = useDispatch();

  const [closed, setClosed] = useState(true);

  const clearSelectedComponent = () => {
    dispatch(setSelectedComponent(null));
  };

  useEffect(() => {
    if (closed) {
      clearSelectedComponent();
    }
  }, [closed]);

  return (
    <>
      {selectedMenu ? (
        <div className={classes.root}>
          <div className={classes.headerContainer}>
            {selectedComponent ? (
              <OptionsHeader
                onBackClick={clearSelectedComponent}
                onCloseClick={() => {
                  setClosed(!closed);
                }}
              />
            ) : (
              <ComponentsHeader
                onCloseClick={() => {
                  setClosed(!closed);
                }}
              />
            )}
          </div>
          <div
            className={clsx(
              classes.wrapper,
              closed ? 'closed' : '',
              selectedComponent ? 'optionsWrapper' : ''
            )}
          >
            {!options &&
              !closed &&
              components &&
              components.map((component) => {
                if (/^surrounding_/.test(component.identifier)) {
                  return <SurroundingItem item={component} key={component.identifier} />;
                }

                // hiding the cooling zone options in the main component list
                const isCoolingZoneOption = component.identifier.includes('cooling_zone_');
                return !isCoolingZoneOption ? (
                  <SelectorItem item={component} key={component.identifier} />
                ) : null;
              })}
            {options && selectedComponent?.identifier === 'cooling_zone' && (
              <CoolingZoneSetup components={coolingZoneComponents} />
            )}
            {options &&
              selectedComponent?.identifier !== 'cooling_zone' &&
              options.map((option) => (
                <SelectorItem
                  item={option}
                  key={option.identifier}
                  isOption={true}
                  component={selectedComponent}
                />
              ))}
            {!options &&
              selectedComponent?.identifier !== 'cooling_zone' &&
              selectedComponent?.entries?.length && <ComponentGroup entries={selectedComponent.entries} />}
          </div>
        </div>
      ) : null}
    </>
  );
};

export default ComponentSelector;
